import * as React from 'react'
import * as clsx from 'clsx'
import { SummaryBoxPromocode } from '@modules/aside/summary-box/summary-box-codes/summary-box-promocode/summary-box-promocode'
import { useReservationApartment } from '@modules/accommodation-selection-step/local-selection/local-selection-map/use-reservation-apartment'
import { useAppSelector } from '@store/index'
import { selectReservation } from '@store/selectors/reservation-selectors'

interface Props {
  wrapperClassName?: string
}

export const SummaryBoxCodes = ({ wrapperClassName }: Props): JSX.Element | null => {
  const { promocode } = useAppSelector(selectReservation)
  const { isSpecialLocalSelected } = useReservationApartment()

  if (isSpecialLocalSelected && !promocode?.code) return null

  return (
    <div className="summary-box__codes">
      <div className={clsx('py-3', wrapperClassName)}>
        <SummaryBoxPromocode />
      </div>
    </div>
  )
}
